import { render, staticRenderFns } from "./table-container.vue?vue&type=template&id=5cbce567&scoped=true"
import script from "./table-container.vue?vue&type=script&lang=js"
export * from "./table-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbce567",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbce567')) {
      api.createRecord('5cbce567', component.options)
    } else {
      api.reload('5cbce567', component.options)
    }
    module.hot.accept("./table-container.vue?vue&type=template&id=5cbce567&scoped=true", function () {
      api.rerender('5cbce567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table-container.vue"
export default component.exports